var map = {
	"./video-carousel.de-CH.json": 1538,
	"./video-carousel.de-DE.json": 1539,
	"./video-carousel.en-CA.json": 1540,
	"./video-carousel.en-GB.json": 1541,
	"./video-carousel.en-IN.json": 1542,
	"./video-carousel.en-ME.json": 1543,
	"./video-carousel.en-US.json": 1544,
	"./video-carousel.es-EM.json": 1545,
	"./video-carousel.es-ES.json": 1546,
	"./video-carousel.fr-BE.json": 1547,
	"./video-carousel.fr-CA.json": 1548,
	"./video-carousel.fr-CH.json": 1549,
	"./video-carousel.nl-BE.json": 1550,
	"./video-carousel.nl-NL.json": 1551,
	"./video-carousel.pl-PL.json": 1552,
	"./video-carousel.pt-BR.json": 1553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;